import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import sitesReducer from './sitesSlice'

const rootReducer = combineReducers({
    auth: authReducer,
    sites: sitesReducer
});

export default rootReducer;
